import {getField, updateField} from 'vuex-map-fields';

const getters = {
    getField,
};

const state = {
    company: {},
    defaultCompany: {id:null,company_id:null,company_name:"None Specified"},
    selectedCompany: {id:null,company_id:null,company_name:"None Specified"},
    filters: {
        search_text: null,
        order_status_ids: [],
        dropship_company_id: null,
    },
};

const mutations = {
    updateField,
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};